export default __webpack_public_path__ + "static/media/Date.dd2bdd1a.svg";